<template>
  <div>
    <!-- <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <b-media class="text-center ml-5 mr-5">
            </b-media>
        </base-header> -->

    <b-container class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-lg-6 mt-5">
          <div class="col-md-12 mt-3">
            <div class="">
              <div class="card bg-secondary shadow border-0">
                <div class="card-body px-lg-5 py-lg-5">
                  <div class="text-center text-muted mb-4">
                    <small>Mettre à jour mot de passe</small>
                  </div>

                  <form role="form">
                    <base-input
                      class="input-group-alternative"
                      placeholder="Mot de passe"
                      type="password"
                      addon-left-icon="ni ni-lock-circle-open"
                      :valid="
                        $v.model.password.$dirty
                          ? !$v.model.password.$error
                          : null
                      "
                      :error="
                        $v.model.password.$dirty && $v.model.password.$error
                          ? !$v.model.password.required
                            ? $t('message.requiredField')
                            : $t('message.minCharacters', { n: 6 })
                          : null
                      "
                      v-model="$v.model.password.$model"
                      @click="clearErrorField('password')"
                    >
                    </base-input>

                    <base-input
                      class="input-group-alternative"
                      placeholder="confirmer votre mot de passe"
                      type="password"
                      addon-left-icon="ni ni-lock-circle-open"
                      :valid="
                        $v.model.password_confirmation.$dirty
                          ? !$v.model.password_confirmation.$error
                          : null
                      "
                      :error="
                        $v.model.password_confirmation.$dirty &&
                        $v.model.password_confirmation.$error
                          ? !$v.model.password_confirmation.required
                            ? $t('message.requiredField')
                            : $t('message.minCharacters', { n: 6 })
                          : null
                      "
                      v-model="$v.model.password_confirmation.$model"
                    >
                    </base-input>
                    <div
                      class="error"
                      v-if="!$v.model.password_confirmation.sameAsPassword"
                    >
                      Passwords must be identical.
                    </div>
                    <div class="error" v-if="errorshasField('password')">
                      {{ getErrorsField("password") }}
                    </div>

                    <div class="text-center">
                      <base-button
                        type="primary"
                        class="my-4"
                        @click="submit"
                        >{{ $t("message.submit") }}</base-button
                      >
                    </div>

                    <span>{{ $t("message.iSymbol") }} :( e.g. @#$%! )</span
                    ><br />
                    <span>{{ $t("message.iNumber") }} :( e.g. 123456 )</span
                    ><br />
                    <span>{{ $t("message.iLoCase") }} :( e.g. abcgh )</span
                    ><br />
                    <span>{{ $t("message.iUpCase") }} :( e.g. ABCDGH )</span
                    ><br />
                    <span
                      >{{ $t("message.iAmChar") }} :( {}[]()/\'"`~,;:.<>)</span
                    >
                  </form>
                </div>
              </div>
            </div>
            <div class="" v-if="hasPatientRole">
              <div class="card bg-secondary shadow border-0">
                <div class="card-body px-lg-5 py-lg-5">
                  <div class="text-center text-muted mb-4">
                    <small>Mettre à jour question sécrète</small>
                  </div>

                  <form role="form">
                    <div
                      class="error"
                      style="color: red"
                      v-if="errorshasField('telephone')"
                    >
                      {{ getErrorsField("telephone") }}
                    </div>
                    <!--                        Question sécrete-->
                    <b-form-group id="question-group" label-for="question">
                      <!-- Options -->
                      <select
                        id="question"
                        v-model="$v.form.question_id.$model"
                        required
                        class="form-control is-invalid retirerBordure"
                      >
                        <option
                          v-for="item in mQuestions"
                          :value="item.value"
                          :key="item.value"
                        >
                          {{ item.text }}
                        </option>
                      </select>
                    </b-form-group>
                    <!--                        Réponse sécrète-->
                    <base-input
                      class="input-group-alternative mb-3"
                      :placeholder="$i18n.t('message.answer')"
                      addon-left-icon="fas fa-reply"
                      :valid="
                        $v.form.reponse.$dirty ? !$v.form.reponse.$error : null
                      "
                      :error="
                        $v.form.reponse.$dirty && $v.form.reponse.$error
                          ? !$v.form.reponse.required
                            ? $t('message.requiredField')
                            : $t('message.reponseNotValid')
                          : null
                      "
                      v-model="$v.form.reponse.$model"
                      @click="clearErrorField('question_id')"
                    >
                    </base-input>
                    <div
                      class="error"
                      style="color: red"
                      v-if="errorshasField('question_id')"
                    >
                      {{ getErrorsField("question_id") }}
                    </div>

                    <div class="text-center">
                      <base-button type="primary" class="my-4" @click="reset">{{
                        $t("message.submit")
                      }}</base-button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { integer, minLength, required, sameAs } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import _ from "lodash";
import SlimSelect from "slim-select";

export default {
  name: "Update",
  computed: {
    ...mapGetters(["errors", "questions", "hasPatientRole"]),

    mQuestions: function () {
      let qArray = [];

      _.forOwn(this.questions, function (value, key) {
        qArray.push({ text: value.intitule, value: value.id });
      });

      return qArray;
    },
  },
  data() {
    return {
      model: {
        password_confirmation: "",
        password: "",
      },
      form: {
        question_id: null,
        reponse: "",
      },
    };
  },

  methods: {
    getQuestionsList() {
      let args = {};

      this.$store.dispatch("getQuestions", { args: args });
    },

    getErrorsField(field) {
      if (this.errorshasField(field)) {
        return this.errors[field][0];
      } else {
        return "";
      }
    },

    errorshasField(field) {
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field) {
      this.$store.dispatch("clearErrorField", { field });

      this.getErrorsField(field);
    },

    submit: function () {
      this.$v.model.$touch();

      if (!this.$v.model.$invalid) {
        let args = {
          user: JSON.parse(localStorage.getItem("user"))["slug"],
          password_confirmation: this.model.password_confirmation,
          password: this.model.password,
        };

        this.$store.dispatch("updatePassword", { args });
      }
    },

    reset: function () {
      this.$v.form.$touch();

      if (!this.$v.form.$invalid) {
        let args = {
          user_id: JSON.parse(localStorage.getItem("user"))["id"],
          question_id: this.form.question_id,
          reponse: this.form.reponse,
        };

        this.$store.dispatch("resetSecretQuestion", { args });
      }
    },
  },

  mounted() {
    // Retrieve list of question
    this.getQuestionsList();

    new SlimSelect({
      select: "#question",
      placeholder: "Select secret question",
    });
  },
  validations: {
    model: {
      password_confirmation: {
        required,
        sameAsPassword: sameAs("password"),
      },

      password: {
        required,
        minLength: minLength(6),
      },
    },
    form: {
      question_id: {
        required,
        integer,
      },
      reponse: {
        required,
        minLength: minLength(3),
      },
    },
  },

  watch: {
    $v: {
      handler: function (val) {
        if (!val.$invalid) {
          //
        }
      },
    },
  },
};
</script>

<style scoped></style>
